/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (resourceConnectId) => (dispatch) => {
    return cecSdk
        .resourceConnect(resourceConnectId)
        .reset()
        .then((resourceConnect) => {
            return resourceConnect;
        });
};
